import React from 'react'

const Header = () => {
  return (
    <>
    <div className=' text-gray-200 bg-gray-900 text-center h-12 flex justify-center items-center font-semibold text-lg'>QR Generator</div>
    </>
  )
}

export default Header